import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveDomain } from '@shared/api/domainApi';
import { useAuthStore } from '@shared/stores/authStore';
import { TextField } from '@shared/ui/primitives/TextField';
import { Button } from '@shared/ui/primitives/Button';
import { toast } from '@shared/ui/feedback/Toast';
import { env } from '@config/env';

export function ProvisionPage(): JSX.Element {
  const navigate = useNavigate();
  const [apiKey, setApiKey] = useState('');
  const [tenantId, setTenantId] = useState(env.guardTenantId ?? '');
  const [domain, setDomain] = useState(env.defaultDomain);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const key = apiKey.trim();
    const tid = tenantId.trim();
    if (!key || !tid) {
      toast.danger('API key and tenant ID are required');
      return;
    }

    setBusy(true);
    try {
      const host = domain.trim() || window.location.hostname;
      await resolveDomain(host);
      await useAuthStore.getState().setApiKeyAuth(key, tid);
      navigate('/', { replace: true });
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Provision failed';
      toast.danger(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#2a1214] px-6 text-[#f8f0ee]">
      <div className="mb-6 max-w-md text-center">
        <h1 className="text-2xl font-semibold">Device provision</h1>
        <p className="mt-2 text-sm text-white/60">
          Paste the kiosk API key and tenant ID. The key must have panic:log:read and
          panic:lifecycle:manage on a role with the panic module licensed.
        </p>
      </div>

      <form onSubmit={onSubmit} className="w-full max-w-md space-y-4">
        <TextField label="Estate domain" value={domain} onChange={(e) => setDomain(e.target.value)} />
        <TextField label="Tenant ID" value={tenantId} onChange={(e) => setTenantId(e.target.value)} required />
        <TextField
          label="API key"
          type="password"
          autoComplete="off"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          required
        />
        <Button type="submit" variant="primary" className="w-full" disabled={busy}>
          {busy ? 'Saving…' : 'Connect NOC'}
        </Button>
      </form>
    </div>
  );
}
